export default "__VITE_ASSET__BNWZzfuI__"